import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'

const EntryItemRow = (props) => {

  const { idText, title, subText, sideComponent } = props
  return(
    <div styleName='entryContainer'>
      <div styleName='entry'>
        <div styleName='titleLine'>
          <span styleName='idText'>{idText} </span>
          {title}
        </div>
        <div styleName='secondaryLine'>{subText}</div>
      </div>
      {sideComponent && <div>{sideComponent}</div>}
    </div>
  )
}

export default CSSModules(styles)(EntryItemRow)